import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PrinterClass } from '../domain/printerClass/printer-class';
import { PrinterClassService } from '../domain/printerClass/printer-class.service';
import { AddPrinterClassDialogComponent } from './add-printer-class-dialog/add-printer-class-dialog.component';
import { DeletePrinterClassDialogComponent } from './delete-printer-class-dialog/delete-printer-class-dialog.component';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { TranslateModule } from '@ngx-translate/core';
import { PrinterTableComponent } from '../printer-table/printer-table.component';

@Component({
  selector: 'app-printer-class',
  templateUrl: './printer-class.component.html',
  standalone: true,
  imports: [
    MatListModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    TranslateModule,
    PrinterTableComponent
  ],
  styleUrls: ['./printer-class.component.css']
})
export class PrinterClassComponent implements OnInit {

  printerClasses: PrinterClass[] = [];

  selectedPrinterClass: PrinterClass;

  newPrinterClass: PrinterClass;

  constructor(
    private printerClassService: PrinterClassService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar) { }

  ngOnInit() {
    this.getPrinterClasses();
  }

  /*******************************************************************
   *
   * PUBLIC API
   *
   ******************************************************************/

  getPrinterClasses() {
    this.printerClassService.getPrinterClasses().subscribe(
      (c) => this.printerClasses = c,
      (err) => console.error(err)
    );
  }

  selectPrinterClass(printerClass: PrinterClass) {
    this.selectedPrinterClass = printerClass;
  }

  openAddPrinterClassDialog(): void {
    const dialogRef = this.dialog.open(
      AddPrinterClassDialogComponent,
      {
        minWidth: '350px', data: { printerClass: this.newPrinterClass }
      });
    dialogRef.afterClosed().subscribe(result => {
      console.log(`AddPrinterDialog result: ${result}`);
      if (result) {
        console.log('Sending result ' + result + ' to backend!');
        console.log(result);
        this.printerClassService.createPrinterClass(result).subscribe(
          (c) => {
            console.log('SUCCESSFULLY created ' + c);
            this.openSnackBar('Druckerklasse ' + c.printerClassName + ' erfolgreich erstellt', 'OK', 3000);
            this.getPrinterClasses();
          },
          (err) => {
            console.error(err),
              this.openSnackBar(err.error.message, 'OK', 10000);
          }
        );
      }
    });
  }

  openDeletePrinterClassDialog(printerClass: PrinterClass): void {
    const dialogRef = this.dialog.open(
      DeletePrinterClassDialogComponent,
      {
        minWidth: '430px', data: printerClass
      });
    dialogRef.afterClosed().subscribe(result => {
      console.log(`AddPrinterDialog result: ${result}`);
      if (result) {
        console.log('Sending result ' + result + ' to backend!');
        console.log(result);
        this.printerClassService.deletePrinterClass(result).subscribe(
          (c) => {
            this.openSnackBar('Druckerklasse erfolgreich gelöscht', 'OK', 3000);
            this.getPrinterClasses();
          },
          (err) => {
            console.error(err),
              this.openSnackBar(err.error.message, 'OK', 10000);
          }
        );
      }
    });
  }


  /*******************************************************************
   *
   * PRIVATE METHODS
   *
   ******************************************************************/

  private openSnackBar(message: string, action: string, duration: number) {
    this.snackBar.open(message, action, {
      duration,
    });
  }
}
